import React, { useState, useMemo, useEffect } from "react";
import Select from 'react-select';
import Helper from "../../helper";
import Application from "../../services/application.service";

const PersonalThree = (props) => {
    let input = props.input
    let tax_refernce_number = [
        "I am not required to be registered for tax (event through income tax is levied by the jurisdication)",
        "No TIN is issued by the jurisdication (because income tax is not levied by the jurisdication)",
        "The TIN is not required to be reported by such jurisdication under local law"
    ]
    const newFirstElement = { label: "None", value: "None" };
    const countries = [newFirstElement].concat(props.countries);

    const [foreignTax, setForeignTax] = useState([{ country: {}, country_issue: "", tax_number: "", is_tax_disabled: false }]);

    useEffect(() => {
        input.is_tax_number = input.is_tax_number ?? 'Y';
        input.tax_refernce_number = (input.tax_refernce_number && input.tax_refernce_number != '') ? input.tax_refernce_number : tax_refernce_number[0];

        if (input.tax_details && input.tax_details.length > 0) {
            var taxes = input.tax_details;
            var tax_arr = [];
            taxes.forEach((arr, i) => {
                var bool = false;
                if (arr.country_issue == 'None') {
                    bool = true;
                }
                tax_arr.push({
                    country: Helper.findCountryByLabel(arr.country_issue, countries), country_issue: arr.country_issue, tax_number: arr.tax_number, is_tax_disabled: bool
                })
            });
            setForeignTax(tax_arr)
        }
    }, []);

    const addForeignTax = () => setForeignTax([...foreignTax, { country: {}, country_issue: "", tax_number: "", is_tax_disabled: false }]);

    const removeForeignTax = index => {
        const list = [...foreignTax];
        list.splice(index, 1);
        setForeignTax(list);
    };

    const handleInputChange = (e, index) => {
        let name, value;
        const list = [...foreignTax];
        if (e.constructor.name == 'Object') {
            value = e;
            name = 'country';
            list[index]['country_issue'] = value.label;
            if (value.label == 'None') {
                list[index]['tax_number'] = '';
                list[index]['is_tax_disabled'] = true;
            } else {
                list[index]['is_tax_disabled'] = false;
            }
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        list[index][name] = value;
        setForeignTax(list);
    };

    const handleSubmit = () => {
        input.tax = foreignTax;
        var formData = Helper.convertFormData(input);
        formData.append('step', 'person3');

        Application.applicationUpdate(formData).then(res => {
            if (res.success === true) {
                props.setFormCount(4);
            }
        }).catch(err => console.log(err));
    }

    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Personal Details</h2>
                    <div className="sub-step-indicator">Step 3/3</div>
                </div>
                <div className="form-fields tax-details">
                    <h5 className="text-title">Tax Details</h5>
                    <div className='row'>
                        <div className="col-lg-6 col-md-12 form-group form-radio-alter">
                            <label>Do you have a Tax Number?</label>
                            <div className="d-flex align-items-center form-radio-wrapper">
                                <div className="form-check pr-4">
                                    <input className="form-check-input" value="Y" type="radio" name="is_tax_number" id="is_tax_number_Y" onChange={props.handleChange} checked={input.is_tax_number == 'Y'} />
                                    <label className="form-check-label pl-2" htmlFor="is_tax_number_Y"> Yes </label>
                                </div>
                                <div className="form-check pr-4">
                                    <input className="form-check-input" value="N" type="radio" name="is_tax_number" id="is_tax_number_N" onChange={props.handleChange} checked={input.is_tax_number == 'N'} />
                                    <label className="form-check-label pl-2" htmlFor="is_tax_number_N"> No </label>
                                </div>
                            </div>
                            <div className="validationAlert"></div>
                        </div>
                        {input.is_tax_number == 'Y' &&
                            <div className="col-lg-6 col-md-12 form-group">
                                <label>Income Tax Number</label>
                                <div className="input-wrap d-flex">
                                    <input type="text" className="form-control" name="income_tax_number" placeholder="IT4512365656" value={input.income_tax_number || ''} onChange={props.handleChange} />
                                </div>
                                <div className="validationAlert"></div>
                            </div>
                        }
                    </div>
                    {input.is_tax_number == 'N' &&
                        <div className="col-lg-12 col-md-12 form-group form-radio-alter form-radio-alter">
                            <div className="row form-radio-wrapper">
                                <p>If you do not have a TIN, please select one of the following:</p>
                                {tax_refernce_number.map((v, i) => {
                                    return (
                                        <div key={i} className="form-check">
                                            <input className="form-check-input" name="tax_refernce_number" onChange={props.handleChange} checked={input.tax_refernce_number === v} type="radio" value={v} id={`radio${i + 1}`} />
                                            <label className="form-check-label pl-2" htmlFor={`radio${i + 1}`}> {v} </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    }
                    <div className="sub-form">
                        <h5 className="text-title">Foreign Tax (if Applicable)</h5>
                        <p className="text-description">Tax residency refers to the country in which you are a resident for tax purposes - the country in which you are registered to pay tax on income. <br />
                            Please indicate in which country(ies) you are a resident for tax purposed (including South Africa).</p>
                        <div className="foreign-tax-table">
                            {foreignTax.map((x, i) => {
                                return <ForeignTax key={i} index={i} arr={x} length={foreignTax.length} removeForeignTax={removeForeignTax} handleInputChange={handleInputChange} countries={countries} />;
                            })}
                        </div>
                        <div className="d-flex justify-content-end">
                            <span className="add-new-row" onClick={addForeignTax}><i className="fa-solid fa-plus"></i> Add More</span>
                        </div>
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper ">
                            <button type="button" className="btn btn-ouline" onClick={(e) => props.setFormCount(2)}>Back</button>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const ForeignTax = props => {
    var arr = props.arr;

    return (
        <div className="row tax-row mt-1 mb-1 py-1">
            {props.length > 1 && (<span className="cancel-btn" onClick={() => props.removeForeignTax(props.index)}><i className="fa fa-times" aria-hidden="true"></i></span>)}
            <div className="col-lg-6 col-md-12 form-group">
                <label htmlFor="name">Country of tax residence</label>
                <div className="input-wrap d-flex">
                    <Select options={props.countries} id={`tax.${props.index}.country_issue`} value={arr.country} onChange={e => props.handleInputChange(e, props.index)} placeholder={'Select'}></Select>
                </div>
                <div className="validationAlert"></div>
            </div>
            <div className="col-lg-6 col-md-12 form-group">
                <label htmlFor="name">Tax refernce Number/TIN</label>
                <div className="input-wrap d-flex">
                    <input type="text" name="tax_number" id={`tax.${props.index}.tax_number`} className="form-control" value={arr.tax_number} onChange={e => props.handleInputChange(e, props.index)} readOnly={arr.is_tax_disabled ?? false} />
                </div>
                <div className="validationAlert"></div>
            </div>
        </div>
    );
}

export default PersonalThree;